export abstract class PersistenceError extends Error {
  public constructor(
    public readonly code: string,
    message: string,
  ) {
    super(message);
    this.name = new.target.name;
  }
}

export class DatabaseUnavailableError extends PersistenceError {
  public constructor() {
    super('database_unavailable', 'Local storage is unavailable.');
  }
}

export class PersistenceReadError extends PersistenceError {
  public constructor() {
    super('persistence_read_failed', 'Local data could not be read.');
  }
}

export class PersistenceWriteError extends PersistenceError {
  public constructor() {
    super('persistence_write_failed', 'Local data could not be saved.');
  }
}

export class PersistenceMigrationError extends PersistenceError {
  public constructor() {
    super('persistence_migration_failed', 'The local database could not be upgraded.');
  }
}

export class PersistenceValidationError extends PersistenceError {
  public constructor() {
    super('persistence_validation_failed', 'Local data failed persistence validation.');
  }
}
